import { render, staticRenderFns } from "./csr.vue?vue&type=template&id=45e9764a&"
import script from "./csr.vue?vue&type=script&lang=js&"
export * from "./csr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports